import Api from "../../../https/Api";
import {
    IBookingPayment,
    IBookingPaymentOrange,
    IDioolMobileTransaction,
    ITransaction,
} from "../../../utils/PaymentInterfaces";
import { IReservation } from "../../../utils/ReservationInterfaces";
import SessionHandler from "../../../https/SessionHandler";
import { IAnnounceAd } from "../../../utils/AnnounceInterfaces";

export class ConfirmationReservationService {
    private api: Api;
    private session: SessionHandler;

    constructor() {
        this.api = new Api();
        this.session = new SessionHandler();
    }

    //get
    async getUserServicesByUserId(userId: string) {
        return this.api.simpleGet("userservices", userId);
    }

    //get reservation by Id
    async getReservationById(reservationId: string) {
        return this.api.simpleGet("reservations/get", reservationId);
    }

    async getCommissionFeeByCountryAndCityId(
        countryName: string,
        cityName: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/commissions-fees-country-city",
            countryName,
            cityName
        );
    }

    async getCommissionFeeByCountryIdAndCityId(
        countryId: string,
        cityId: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/commissions-fees-country-city-by-id",
            countryId,
            cityId
        );
    }

    async getHostFeeByCountryIdAndCityId(
        countryId: string,
        cityId: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/host-fees-country-city-by-id",
            countryId,
            cityId
        );
    }


    async getSpecialFeeByPropertyType(propertyType: string) {
        return this.api.simpleGet(
            "settings/specials-fees/property-type",
            propertyType
        );
    }

    async getTransactionById(id: string) {
        return this.api.simpleGet("transactions-details/get", id);
    }

    async getTransactionDetailByReservationId(id: string) {
        return this.api.simpleGet("transactions-details/reservation", id);
    }

    async getTransactionIdByRefundedReservationId(id: string) {
        return this.api.simpleGet(
            "transactions-id-by-refunded/reservation",
            id
        );
    }

    async sendReservationNotification(id: string) {
        return this.api.simpleGet(
            "reservations/sendReservationNotification",
            id
        );
    }

    async sendCustomerServiceNotification(id: string) {
        return this.api.simpleGet(
            "reservations/reservations/customerServiceNotification",
            id
        );
    }

    async sendGuestConfirmation(id: string) {
        return this.api.simpleGet(
            "reservations/reservations/guestConfirmation",
            id
        );
    }

    async getReservationChangeLogs(id: string) {
        return this.api.simpleGet(
            "reservations/getLogChanges/",
            id
        );
    }


    async getAdvancePercentageByCountryId(countryId: string) {
        return this.api.simpleGet(
            "settings/advance-percentage/country",
            countryId
        );
    }
    
   
    //post
    async createPayment(paymentData: IBookingPayment) {

        console.log("Validated Payment Request:", paymentData);
        return this.api.post("payments/v2/create/booking", paymentData);
    }
        
  
   /*
    async createPayment(paymentData: IBookingPayment) {
    try {
        // 1. Validate Root-Level Fields
        if (!paymentData?.method) {
            throw new Error("Payment method is required (e.g., 'paypal')");
        }

        // 2. Validate Transaction Structure
        if (!paymentData.transaction) {
            throw new Error("Transaction data is missing");
        }

        // 3. Validate Amount
        if (typeof paymentData.transaction.amount?.total !== 'number' || paymentData.transaction.amount.total <= 0) {
            throw new Error(`Invalid amount: ${paymentData.transaction.amount?.total || 'undefined'}`);
        }

        // 4. Validate Currency
        if (!paymentData.transaction.items.booking.announce.devise) {
            throw new Error("Currency code is required (e.g., 'EUR')");
        }

        // 5. Validate Items (if applicable)
        if (!paymentData.transaction.items || !Array.isArray(paymentData.transaction.items)) {
            throw new Error("Items array is missing or invalid");
        }

        // 6. Log the validated request (for debugging)
        console.log("Validated Payment Request:", {
            method: paymentData.method,
            amount: paymentData.transaction.amount.total,
            currency: paymentData.transaction.items.booking.announce.devise,
            itemCount: paymentData.transaction.items.length
        });

        // 7. API Call with Timeout
        const response = await Promise.race([
            this.api.post("payments/v2/create/booking", paymentData),
            new Promise((_, reject) => 
                setTimeout(() => reject(new Error("API timeout after 5s")), 5000)
            )
        ]);

        
        
        
        if (!response.data) {
            throw new Error("Empty API response");
        }

        if (response.data.error) {
            throw new Error(`API Error: ${response.data.error}`);
        }

        if (!response.data.success) {
            throw new Error(`Payment failed: ${response.data.message || 'No details provided'}`);
        }

        return response.data;

    } catch (error) {
        console.error("Payment Creation Failed:", {
            error: error,
            failedStep: "Service Layer",
            inputData: { // Truncated for security
                method: paymentData?.method,
                amount: paymentData?.transaction?.amount?.total
            }
        });
        throw error; // Preserve stack trace
    }
} */

    async createTemporary(reservation: IReservation) {
        return this.api.post("reservations/create/temporary", reservation);
    }

    async createTemporaryAnnounceAd(announceAd: IAnnounceAd) {
        return this.api.post("announces-ads/create/temporary", announceAd);
    }

    async createDioolPayment(paymentData: IBookingPayment) {
        return this.api.post("diool/transactions/create", paymentData);
    }


    async saveReservation(reservation: IReservation) {
        try {
            const response = await this.api.post("reservations/create", reservation);
            console.log("API Response:", response);
            return response; // ✅ This is now jsonResponse (correct)
        } catch (error) {
            console.error("API Error Details:", error);
            throw error;
        }
    }


    async saveDioolTransaction(dioolTransaction: IDioolMobileTransaction) {
        return this.api.post("diool/payment-request", dioolTransaction);
    }

    async saveTransaction(transaction: ITransaction) {
        return this.api.post("transactions/create", transaction);
    }
    async getUser(id: String) {
        return this.api.simpleGet("users/get", id as string);
    }

    async createPaymentOrange(paymentDataOrange: IBookingPaymentOrange) {
        return this.api.post(
            "payments/orange/create/booking",
            paymentDataOrange
        );
    }
    async updateCredit(id: string, credit: number) {
        let state = {
            userID: id,
            credit: credit,
        };
        return this.api.post("users/updateCredit", state);
    }

    async getDohoneInfo() {
        return this.api.get("dohone");
    }

}
